import { Dialog, DialogTitle, Button, DialogActions, TextField } from "@mui/material";

const ConfirmationPopupDsr = ({
    openDeleteModal,
    handleOnDeleteClick,
    handleCloseDeleteConfirmationModal,
    isLoading,
    messageHeading,
    messageBody,
    loadingMessage,
    reason,
    setReason,
}) => {
    return (
        <Dialog open={openDeleteModal}>
            <DialogTitle id="alert-dialog-title">
                <p id="warning-message">{messageHeading}</p>
                <hr />
                {messageBody}
                <TextField
                    fullWidth
                    margin="dense"
                    label="Reason for Deactivation"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    disabled={isLoading}
                    required // <-- makes it mandatory
                />
            </DialogTitle>
            <DialogActions>
                <Button
                    id="button-yes"
                    onClick={() => handleOnDeleteClick()}
                    disabled={isLoading || !reason.trim()}
                    sx={{
                        color: "white",
                        backgroundColor: "green",
                        borderRadius: "4px",
                        fontStyle: "normal",
                        height: "2.4rem",
                        width: "50% !important",
                        margin: "1rem",
                        fontSize: "15px",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        "&:disabled": {
                            backgroundColor: "gray",   // <-- disabled background
                            color: "#ccc",             // <-- disabled text
                            cursor: "not-allowed",
                            opacity: 0.6
                        }
                    }}
                >
                    {isLoading ? (loadingMessage ? loadingMessage : "Deleting...") : "Yes"}
                </Button>

                <Button
                    id="button-no"
                    onClick={() => handleCloseDeleteConfirmationModal()}
                    disabled={isLoading}
                >
                    No
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationPopupDsr;
